import { ConfigContext } from '@/contextAPI/configContext';
import { useContext } from 'react';

export function useConfigValue<T>(path: string[]): T | undefined {
  const config = useContext(ConfigContext);
  return path.reduce((obj, key) => (obj && obj[key] !== undefined ? obj[key] : null), config) as T | undefined;
 }
